import { createFileRoute } from '@tanstack/react-router';
import { NewProjectPage } from '../features/projects/new-project-page';
export const Route = createFileRoute('/manage/$companySlug/projects/new')({
  component: NewProjectRoute,
});
function NewProjectRoute() {
  const { companySlug } = Route.useParams();
  return <NewProjectPage companySlug={companySlug} />;
}
